const ROOT = "polls-viewer";
const INSERT_POLL_BUTTON = "insert-poll-button";
const INSERT_POLL_MODAL = "insert-poll-modal";
const INSERT_POLL_MODAL_THUMBNAIL_PICKER = "insert-poll-modal-thumbnail-picker";
const INSERT_POLL_MODAL_THUMBNAIL = "insert-poll-modal-thumbnail-";
const POLLS_MULTIPLE_ANSWER_TEXT = "polls-multiple-answer-text";
const POLLS_QUESTION_IMAGE = "polls-question-image";
const POLLS_ANSWER_IMAGE = "polls-answer-image";
const POLLS_ANSWER_ITEMS = "polls-answer-items";
const POLLS_QUESTION_TEXT_INPUT = "polls-question-text-input";
const POLLS_ANSWER_TEXT_INPUT = "polls-answer-text-input";
const POLLS_VOTED_USER_ITEM = "polls-voted-user-item";
const POLLS_ADD_ANSWER_BUTTON = "polls-add-answer-item-button";
const POLLS_REMOVE_ANSWER_BUTTON = "polls-remove-answer-item-button";
const POLLS_ITEM_PERCENTAGE_PREVIEW = "polls-items-percentage-preview";
const PLUGIN_TOOLBAR_LAYOUT_DROPDOWN_BUTTON = "plugin-toolbar-layout-dropdown-button";
const LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT = "layout-dropdown-option-customize-layout";
const LAYOUT_DROPDOWN_OPTION_GRID = "layout-dropdown-option-grid";
const LAYOUT_DROPDOWN_OPTION_LIST = "layout-dropdown-option-list";
const SETTINGS_MODAL = "poll-settings-modal";
const SETTINGS_TABS = "settings-tabs";
const SETTINGS_LAYOUT_TAB = "settings-layout-tab";
const SETTINGS_DESIGN_TAB = "settings-design-tab";
const SETTINGS_GENERAL_TAB = "settings-general-tab";
const GENERAL_SETTINGS_MULTIPLE_ANSWERS_TOGGLE = "general-settings-multiple-answers-toggle";
const GENERAL_SETTINGS_VOTE_COUNT_TOGGLE = "general-settings-vote-count-toggle";
const GENERAL_SETTINGS_EACH_PERSON_VOTE_TOGGLE = "general-settings-each-person-vote-toggle";
const GENERAL_SETTINGS_VIEW_PERMISSIONS_RADIO_GROUP = "general-settings-view-permissions-radio-group";
const GENERAL_SETTINGS_VOTE_PERMISSIONS_RADIO_GROUP = "general-settings-vote-permissions-radio-group";
const LAYOUT_SETTINGS_IMAGE_TO_QUESTION_TOGGLE = "layout-settings-image-to-question-toggle";
const LAYOUT_SETTINGS_IMAGE_TO_ANSWERS_TOGGLE = "layout-settings-image-to-answers-toggle";
const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL_PICKER = "layout-settings-layout-thumbnail-picker";
const LAYOUT_SETTINGS_LAYOUT_THUMBNAIL = "layout-settings-layout-thumbnail-";
const LAYOUT_SETTINGS_DIRECTION_TOGGLE = "layout-settings-direction-toggle";
const DESIGN_SETTINGS_BACKGROUND_THUMBNAIL_PICKER = "design-settings-background-thumbnail-picker";
const DESIGN_SETTINGS_BACKGROUND_THUMBNAIL = "design-settings-background-thumbnail-";
const DESIGN_SETTINGS_BACKGROUND_GRADIENT_BUTTON = "design-settings-background-gradient-button";
const DESIGN_SETTINGS_BACKGROUND_COLOR_BUTTON = "design-settings-background-color-button";
const DESIGN_SETTINGS_BACKGROUND_IMAGE_BUTTON = "design-settings-background-image-button";
const DESIGN_SETTINGS_CORNER_RADIUS_SLIDER = "design-settings-border-radius-slider";
const DESIGN_SETTINGS_CORNER_RADIUS_INPUT = "design-settings-border-radius-input";
const DESIGN_SETTINGS_ANSWERS_CORNER_RADIUS_SLIDER = "design-settings-answers-corner-radius-slider";
const DESIGN_SETTINGS_ANSWERS_CORNER_RADIUS_INPUT = "design-settings-answers-corner-radius-input";
export {
  DESIGN_SETTINGS_ANSWERS_CORNER_RADIUS_INPUT,
  DESIGN_SETTINGS_ANSWERS_CORNER_RADIUS_SLIDER,
  DESIGN_SETTINGS_BACKGROUND_COLOR_BUTTON,
  DESIGN_SETTINGS_BACKGROUND_GRADIENT_BUTTON,
  DESIGN_SETTINGS_BACKGROUND_IMAGE_BUTTON,
  DESIGN_SETTINGS_BACKGROUND_THUMBNAIL,
  DESIGN_SETTINGS_BACKGROUND_THUMBNAIL_PICKER,
  DESIGN_SETTINGS_CORNER_RADIUS_INPUT,
  DESIGN_SETTINGS_CORNER_RADIUS_SLIDER,
  GENERAL_SETTINGS_EACH_PERSON_VOTE_TOGGLE,
  GENERAL_SETTINGS_MULTIPLE_ANSWERS_TOGGLE,
  GENERAL_SETTINGS_VIEW_PERMISSIONS_RADIO_GROUP,
  GENERAL_SETTINGS_VOTE_COUNT_TOGGLE,
  GENERAL_SETTINGS_VOTE_PERMISSIONS_RADIO_GROUP,
  INSERT_POLL_BUTTON,
  INSERT_POLL_MODAL,
  INSERT_POLL_MODAL_THUMBNAIL,
  INSERT_POLL_MODAL_THUMBNAIL_PICKER,
  LAYOUT_DROPDOWN_OPTION_CUSTOMIZE_LAYOUT,
  LAYOUT_DROPDOWN_OPTION_GRID,
  LAYOUT_DROPDOWN_OPTION_LIST,
  LAYOUT_SETTINGS_DIRECTION_TOGGLE,
  LAYOUT_SETTINGS_IMAGE_TO_ANSWERS_TOGGLE,
  LAYOUT_SETTINGS_IMAGE_TO_QUESTION_TOGGLE,
  LAYOUT_SETTINGS_LAYOUT_THUMBNAIL,
  LAYOUT_SETTINGS_LAYOUT_THUMBNAIL_PICKER,
  PLUGIN_TOOLBAR_LAYOUT_DROPDOWN_BUTTON,
  POLLS_ADD_ANSWER_BUTTON,
  POLLS_ANSWER_IMAGE,
  POLLS_ANSWER_ITEMS,
  POLLS_ANSWER_TEXT_INPUT,
  POLLS_ITEM_PERCENTAGE_PREVIEW,
  POLLS_MULTIPLE_ANSWER_TEXT,
  POLLS_QUESTION_IMAGE,
  POLLS_QUESTION_TEXT_INPUT,
  POLLS_REMOVE_ANSWER_BUTTON,
  POLLS_VOTED_USER_ITEM,
  ROOT,
  SETTINGS_DESIGN_TAB,
  SETTINGS_GENERAL_TAB,
  SETTINGS_LAYOUT_TAB,
  SETTINGS_MODAL,
  SETTINGS_TABS
};
//# sourceMappingURL=data-hooks.js.map
